<div class="mt-4 pt-5 mx-5">
  <div *ngIf="scanResultData" class="mt-5 d-flex justify-content-between">
    <div>
      <h3 class="hello">
        {{ "Hello" | translate }} {{ user ? ", " + user.name : "" }}
      </h3>
      <p class="welcome">{{ "Welcome to your linkedin profile review." | translate }}</p>
      <div class="d-flex flex-wrap">
        <div class="text-center mx-3">
          <img
            class="item-img"
            src=".././../../assets/icon/resume sections.png"
          />
          <h3 class="title">{{ "Headline" | translate }}</h3>
          <span class="presentage">{{ cvScores.headline }}%</span>
        </div>
        <div class="text-center mx-3">
          <img class="item-img" src=".././../../assets/icon/style.png" />
          <h3 class="title">{{ "Summary" | translate }}</h3>
          <span class="presentage">{{ cvScores.summary }}%</span>
        </div>
        <div class="text-center mx-3">
          <img class="item-img" src=".././../../assets/icon/skills.png" />
          <h3 class="title">{{ "Experience" | translate }}</h3>
          <span class="presentage">{{ cvScores.experience }}%</span>
        </div>
        <div class="text-center mx-3">
          <img class="item-img" src=".././../../assets/icon/content.png " />
          <h3 class="title">{{ "Education" | translate }}</h3>
          <span class="presentage">{{ cvScores.education }}%</span>
        </div>
        <div class="text-center mx-3">
          <img class="item-img" src=".././../../assets/icon/format.png" />
          <h3 class="title">{{ "Technical" | translate }}</h3>
          <span class="presentage">{{ cvScores.technical }}%</span>
        </div>
      </div>
    </div>

    <app-circle-progress [progressValue]="cvScores.total" />
  </div>
  <div *ngIf="scanResultData" class="accodion-container">
    <p-accordion [multiple]="true">
      <!-- headline -->
      <p-accordionTab [toggleable]="true">
        <ng-template pTemplate="header">
          <img
            class="item-img"
            src=".././../../assets/icon/resume sections.png"
          />
          <span class="mx-2"> {{ "Headline" | translate }} </span>

          <div class="circle-progress">
            <app-circle-progress [progressValue]="cvScores.headline" />
          </div>
        </ng-template>

        <div class="check" *ngFor="let key of getKeys(scanResultData.headline)">
          <img [src]="getCheckIcon(key)" />
          <div>
            <h3>{{ getTitleAndDescription('headline', key).title }}</h3>
            <span>{{ getTitleAndDescription('headline', key).description }}</span>            
          </div>
        </div>
      </p-accordionTab>

      <!-- summary -->
      <p-accordionTab [toggleable]="true">
        <ng-template pTemplate="header">
          <img class="item-img" src=".././../../assets/icon/style.png" />
          <span class="mx-2"> {{ "Summary" | translate }} </span>

          <div class="circle-progress">
            <app-circle-progress [progressValue]="cvScores.summary" />
          </div>
        </ng-template>

        <div class="check" *ngFor="let key of getKeys(scanResultData.summary)">
          <img [src]="getCheckIcon(key)" />
          <div>
            <h3>{{ getTitleAndDescription('summary', key).title }}</h3>
            <span>{{ getTitleAndDescription('summary', key).description }}</span>
          </div>
        </div>
      </p-accordionTab>

      <!-- experience -->
      <p-accordionTab [toggleable]="true">
        <ng-template pTemplate="header">
          <img class="item-img" src=".././../../assets/icon/content.png" />
          <span class="mx-2"> {{ "Experience" | translate }} </span>

          <div class="circle-progress">
            <app-circle-progress [progressValue]="cvScores.experience" />
          </div>
        </ng-template>

        <div *ngFor="let experience of scanResultData.experience">
          <div *ngFor="let key of getKeys(experience)">
            <div class="check">
              <img [src]="getCheckIcon(key)" />
              <div>
                <h3>{{ getTitleAndDescription('experience', key).title }}</h3>
                <span>{{ getTitleAndDescription('experience', key).description }}</span>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </p-accordionTab>

      <!-- education -->
      <p-accordionTab [toggleable]="true">
        <ng-template pTemplate="header">
          <img class="item-img" src=".././../../assets/icon/skills.png" />
          <span class="mx-2"> {{ "Education" | translate }} </span>

          <div class="circle-progress">
            <app-circle-progress [progressValue]="cvScores.education" />
          </div>
        </ng-template>

        <div *ngFor="let education of scanResultData.education">
          <div class="check" *ngFor="let key of getKeys(education)">
            <img [src]="getCheckIcon(key)" />
            <div>
              <h3>{{ getTitleAndDescription('education', key).title }}</h3>
              <span>{{ getTitleAndDescription('education', key).description }}</span>
            </div>
          </div>
          <hr />
        </div>
      </p-accordionTab>

      <!-- technical -->
      <p-accordionTab [toggleable]="true">
        <ng-template pTemplate="header">
          <img class="item-img" src=".././../../assets/icon/format.png" />
          <span class="mx-2"> {{ "Technical" | translate }} </span>

          <div class="circle-progress">
            <app-circle-progress [progressValue]="cvScores.technical" />
          </div>
        </ng-template>

          <div class="check" *ngFor="let key of getKeys(scanResultData.technical)">
            <img [src]="getCheckIcon(key)" />
            <div>
              <h3>{{ getTitleAndDescription('technical', key).title }}</h3>
              <span>{{ getTitleAndDescription('technical', key).description }}</span>
            </div>
          </div>
          <hr />
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
